package games.polyclub.website.frontend.store.hooks

import games.polyclub.website.frontend.store.StoreBff

fun useLogout(): suspend () -> Unit {
    val ctx = useAuth()

    suspend fun logout() {
        ctx.setAuth(null)
        StoreBff.logout()
    }
    return ::logout
}
